import {
    DownOutlined,
    FullscreenOutlined,
    LoadingOutlined,
} from "@ant-design/icons";
import { Card, DatePicker, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { disableFutureDates, formatDate } from "../../services/util";
import moment from "moment";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import Chart from "react-google-charts";
import { pieChartConfigurationOption } from "../../config";
import { SupportTicketTable } from "./SupportTicketTable";

function IssueComponentChart() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [chartData, setChartData] = useState([]);
    const [enableZoom, setEnableZoom] = useState(false);
    const [hotelListOptions, setHotelListOptions] = useState([]);
    const [selectedHotels, setSelectedHotels] = useState([]);
    const [selectedComponentForTableView, setSelectedComponentForTableView] =
        useState("");
    const [formData, setFormData] = useState({
        start_date: formatDate(moment().subtract(7, "day")),
        end_date: formatDate(moment()),
        staff_id,
        hotel_ids: selectedHotels,
    });

    const {
        status,
        data,
        refetch: getHotels,
    } = useQuery(
        "hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", formData);
        },
        { enabled: false },
    );

    const {
        chartStatus,
        data: ComponentWiseTopIssueRate,
        refetch,
    } = useQuery(
        "TopIssueComponentChart",
        async () => {
            return await HTTP(`/dashboard/getTopIssuesComponentsHotelWise`, {
                ...formData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        getHotels();
        refetch();
    }, []);

    useEffect(() => {
        refetch();
    }, [formData]);

    useEffect(() => {
        if (status === "success") {
            setHotelListOptions(data.data);
        }
    }, [status, data]);

    useEffect(() => {
        setChartData(ComponentWiseTopIssueRate?.data);
    }, [ComponentWiseTopIssueRate]);

    useEffect(() => {
        setFormData({ ...formData, hotel_ids: selectedHotels });
    }, [selectedHotels]);

    const handleSelectChange = (e) => {
        setSelectedHotels(e);
    };

    return (
        <Card className="box-shadow" style={{ width: "45%" }}>
            <div className="flex space-between">
                <strong>Top 5 Issue Components</strong>
                <div className="flex flex-gap-10 align-center">
                    <DatePicker.RangePicker
                        defaultValue={[
                            moment(formData.start_date),
                            moment(formData.end_date),
                        ]}
                        value={[
                            moment(formData.start_date),
                            moment(formData.end_date),
                        ]}
                        allowClear={false}
                        disabledDate={disableFutureDates}
                        format="MM/DD/YYYY"
                        ranges={{
                            "Last 7 Days": [
                                moment().subtract(7, "day"),
                                moment(),
                            ],
                            "Last 30 Days": [
                                moment().subtract(29, "day"),
                                moment(),
                            ],
                            "Current Month": [
                                moment().startOf("month"),
                                moment(),
                            ],
                            "Last Month": [
                                moment().subtract(1, "month").startOf("month"),
                                moment().subtract(1, "month").endOf("month"),
                            ],
                            "Last 3 Month": [
                                moment().subtract(3, "month"),
                                moment(),
                            ],
                        }}
                        onChange={(e) => {
                            console.log(e);
                            setFormData({
                                ...formData,
                                start_date: formatDate(e[0]),
                                end_date: formatDate(e[1]),
                            });
                        }}
                    />
                    <Select
                        defaultValue={selectedHotels}
                        value={selectedHotels}
                        suffixIcon={<DownOutlined />}
                        allowClear
                        mode="multiple"
                        className="select-container"
                        placeholder="Hotel"
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        onChange={handleSelectChange}
                        loading={hotelListOptions.length === 0 ? true : false}
                        style={{ width: "250px" }}
                    >
                        {hotelListOptions.map((option) => (
                            <Select.Option
                                key={option.hotel_id}
                                value={option.hotel_id}
                            >
                                {`${option.hotel_name}`}
                            </Select.Option>
                        ))}
                    </Select>
                    <FullscreenOutlined
                        style={{ fontSize: "20px" }}
                        onClick={() => {
                            setEnableZoom(true);
                        }}
                    />
                </div>
            </div>
            {chartData?.length > 0 ? (
                <Chart
                    options={{
                        ...pieChartConfigurationOption,
                        slices: {},
                    }}
                    data={chartData}
                    chartType="PieChart"
                    chartEvents={[
                        {
                            eventName: "select",
                            callback({ chartWrapper }) {
                                if (
                                    chartWrapper.getChart().getSelection()
                                        .length > 0
                                ) {
                                    setSelectedComponentForTableView(
                                        chartData[
                                            chartWrapper
                                                .getChart()
                                                .getSelection()[0].row + 1
                                        ][0],
                                    );
                                } else {
                                    setSelectedHotelForTableView(0);
                                }
                            },
                        },
                    ]}
                />
            ) : (
                <Spin
                    indicator={
                        <LoadingOutlined style={{ fontSize: 48 }} spin />
                    }
                />
            )}

            <Modal
                open={enableZoom}
                destroyOnClose
                onCancel={() => {
                    setEnableZoom(false);
                }}
                width={"fit-content"}
                height={"fit-content"}
                footer={""}
            >
                <Chart
                    options={{
                        title: "Top 5 Issue Components",
                        ...pieChartConfigurationOption,
                        slices: {},

                        width: "60vw",
                        height: "70vh",
                    }}
                    data={chartData}
                    chartType="PieChart"
                />
            </Modal>
            <Modal
                open={selectedComponentForTableView != ""}
                destroyOnClose
                onCancel={() => {
                    setSelectedComponentForTableView("");
                }}
                width={"fit-content"}
                footer={""}
            >
                <SupportTicketTable
                    component_name={selectedComponentForTableView}
                    start_date={formData.start_date}
                    end_date={formData.end_date}
                />
            </Modal>
        </Card>
    );
}

export default IssueComponentChart;
